import {  BRACKET_SETTINGS_ACTION } from 'core/constants/Actions'
import { TypedThunk, TypedDispatch } from 'App/Store'
import { getStoreById } from 'core/services/Store'
import { getBracektSettings } from 'core/services/TournamnetBracket'

export function getBracketSettingsDetails(tournamentId: string | string, params: any): TypedThunk {
  return async (dispatch: TypedDispatch) => {
    dispatch({ type: BRACKET_SETTINGS_ACTION.REQUEST })
    const apiResponse = await getBracektSettings(tournamentId ,params)
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: BRACKET_SETTINGS_ACTION.SUCCESS,
        payload: { bracketRounds: apiResponse.data.bracketRounds }
      })
    } else {
      dispatch({
        type: BRACKET_SETTINGS_ACTION.FAILURE
      })
    }
  }
}

export function resetStoreDetails() {
  return {
    type: BRACKET_SETTINGS_ACTION.RESET
  }
}